import Model    from 'scripts/poppet/model';

/**
 * defa.models.AlarmGroup
 * The DEFA AlarmGroup model.
 * @version 1.2.0
 */

const api     = {
	alarmGroups: '/alarmgroups',
};

const AlarmGroup = Model.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	urlRoot: api.alarmGroups,
	
	defaults: {
		alarmCentral    : !1,
		insuranceCompany: !1,
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
} );


export default AlarmGroup;